import { jsx as r, jsxs as f } from "react/jsx-runtime";
import { CloseButton as z } from "./closeButton.js";
import { useRef as E, useState as v, useEffect as w } from "react";
import { u as n } from "./index-6a632112.mjs";
import { S as M } from "./caretLeft-980c1667.mjs";
import { S as X } from "./caretRight-e0ea6357.mjs";
import { r as x, n as m, s as t, c as s, Q as d, d as I, a as T, h as A, e as R } from "./themes-5f0b3c3d.mjs";
import { l as k } from "./lineHeights-72d3110c.mjs";
import { AspectRatio as U } from "./aspectRatio.js";
import { b as D, M as H } from "./modalMixedStructure.modalWindow-3bb1e4ef.mjs";
import { useWindowDimensions as N } from "./useWindowDimensions.js";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./button.js";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
import "react-dom";
import "./zIndices-d07533f3.mjs";
import "./index-c8707610.mjs";
import "./tslib.es6-59e1c9d8.mjs";
import "./superScript-393c70dc.mjs";
import "./disclosure.js";
import "./hTag-40b23797.mjs";
const Q = n.div`
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  align-self: stretch;
  border-radius: ${x["4x"]};
  background: ${m.components.PhotoGalleryLightbox.mainContainercolor};
`, F = n.div`
  display: flex;
  padding: ${t["4x"]} ${t["5x"]} 0px ${t["5x"]};
  justify-content: flex-end;
  align-items: flex-start;
  align-self: stretch;
  border-radius: ${t["5x"]} ${t["5x"]} 0px 0px;

  &:focus-visible {
    outline: 2px solid ${s.brandGrabber[1e3]};
  }
  background: rgba(0, 20, 46, 0.8);
  border-radius: unset;

  @media ${d.tabletAndUp} {
    padding: ${t["4x"]} ${t["8x"]} 0px ${t["8x"]};
    background: #fff;
    border-radius: ${t["5x"]} ${t["5x"]} 0px 0px;
  }
`, O = n.div`
  position: relative;
  width: 100%;

  img {
    position: absolute;
    object-fit: cover;
    border-radius: ${x["4x"]} ${x["4x"]} 0px 0px;
  }
  :nth-child(2) {
    padding-bottom: 54.25%;
    background: rgba(0, 20, 46, 0.8);
  }

  @media ${d.tabletAndUp} {
    img {
      border-radius: unset;
    }
  }
`, q = n.div`
  display: flex;
  padding: ${t["6x"]} ${t["5x"]} ${t["8x"]} ${t["5x"]};
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: ${t["1x"]};
  @media ${d.tabletAndUp} {
    padding: ${t["8x"]} ${t["8x"]} ${t["12x"]} ${t["8x"]};
  }
`, J = n.div`
  color: ${m.components.PhotoGalleryLightbox.photoTitleColor};
  font-family: ${I.headline};
  font-size: ${T.xxxxlarge};
  font-style: normal;
  font-weight: ${A.XL.fontWeight};
  line-height: ${k.xxlarge};
`, K = n.div`
  width: 100%;
  font-family: ${I.body};
  font-size: ${T.medium};
  font-style: normal;
  font-weight: ${R.medium.L.fontWeight};
  line-height: ${k.medium};
  color: ${m.components.PhotoGalleryLightbox.photoDescColor};
  align-self: stretch;
  overflow: hidden;
  text-overflow: ellipsis;
`, V = n.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding-top: 5px;
`, C = n.button`
  position: absolute;
  z-index: 1;

  top: 45%;
  ${(e) => e.$flag === "left" ? "left: 3%;" : "right: 3% ;"}

  height: 48px;
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: ${t["2x"]};
  cursor: pointer;
  background-color: ${(e) => e.theme.components.PhotoGalleryLightbox.navButtonBackgroundColor};
  color: ${(e) => e.theme.components.PhotoGalleryLightbox.navCaretColor};

  &:focus-visible {
    outline: 2px solid ${s.accentBlue[1e3]};
  }

  &:disabled {
    cursor: auto;
    color: ${s.brandTwilight[500]};
  }

  &:hover:not([disabled]) {
    background-color: ${s.accentBlue[1e3]};
    color: ${s.brandTwilight[0]};
  }

  @media ${d.mobile} {
    display: none;
  }
`, Y = n(H)`
  padding: unset;
  box-shadow: unset;
  border-radius: 16px;

  @media ${d.mobile} {
    border-radius: unset;
    min-width: 100vw;
  }
`;
function It({
  images: e = [{ src: "", title: "", description: "" }],
  onClose: g,
  className: W,
  autoImageChange: L = !1,
  isOpen: S = !1,
  imageInterval: j = 3e3,
  activeIndex: p = 1,
  ...Z
}) {
  const c = E(null), { width: b } = N(), [i, a] = v(p), [h, u] = v({
    src: "",
    title: "",
    description: ""
  }), l = e?.length, $ = () => {
    if (i >= 1) {
      const o = i === 1 ? l : i - 1;
      u({
        src: e[o - 1]?.src || "",
        title: e[o - 1]?.title || "",
        description: e[o - 1]?.description || ""
      }), a(o);
    }
  }, y = () => {
    if (i <= l) {
      const o = i === l ? 1 : i + 1;
      u({
        src: e[o - 1]?.src || "",
        title: e[o - 1]?.title || "",
        description: e[o - 1]?.description || ""
      }), a(o);
    }
  }, P = (o) => {
    b > 599 || (c.current = o.touches[0].clientX);
  }, B = (o) => {
    c.current !== null && (b > 599 || (c?.current - o.changedTouches[0].clientX > 50 ? y() : o.changedTouches[0].clientX - c?.current > 50 && $()));
  };
  return w(() => {
    if (u({
      src: e[i - 1]?.src || "",
      title: e[i - 1]?.title || "",
      description: e[i - 1]?.description || ""
    }), L) {
      if (i <= l) {
        const o = setInterval(() => {
          const G = i % l + 1;
          a(G);
        }, j);
        return () => clearInterval(o);
      }
      a(1);
    }
  }, [i]), w(() => {
    a(p);
  }, [p]), e?.length > 0 ? /* @__PURE__ */ r(
    Y,
    {
      variant: "large",
      isOpen: S,
      onClose: g,
      bgOverlayColor: "rgba(0,20,46,0.80)",
      children: /* @__PURE__ */ r(D, { children: /* @__PURE__ */ f(Q, { className: W, children: [
        /* @__PURE__ */ r(F, { children: /* @__PURE__ */ r(
          z,
          {
            ariaLabel: "closebutnoflightbox",
            onClick: g,
            size: "large"
          }
        ) }),
        /* @__PURE__ */ f(O, { children: [
          /* @__PURE__ */ r(
            C,
            {
              tabIndex: 0,
              onClick: $,
              "aria-label": "prev",
              $flag: "left",
              children: /* @__PURE__ */ r(M, { height: "20px", width: "20px" })
            }
          ),
          /* @__PURE__ */ r(U, { ratio: "16/9", objectFit: "contain", children: /* @__PURE__ */ r(
            "img",
            {
              src: h?.src,
              alt: "Images",
              onTouchStart: P,
              onTouchEnd: B
            }
          ) }),
          /* @__PURE__ */ r(
            C,
            {
              tabIndex: 0,
              onClick: y,
              "aria-label": "next",
              $flag: "right",
              children: /* @__PURE__ */ r(X, { height: "20px", width: "20px" })
            }
          )
        ] }),
        /* @__PURE__ */ r(
          V,
          {
            style: { alignItems: "center" },
            children: `${i}/${l}`
          }
        ),
        /* @__PURE__ */ f(q, { children: [
          /* @__PURE__ */ r(J, { children: h?.title }),
          /* @__PURE__ */ r(K, { children: h?.description })
        ] })
      ] }) })
    }
  ) : null;
}
export {
  It as PhotoGalleryLightbox
};
